import React from 'react';
import Icon from '../Atoms/icon/icon';
import { IconscoutIcons } from '../Atoms/icon/iconscout-icon';
import { Link } from 'gatsby';

export interface IBreadcrumb {
  text: string;
  link?: string;
}

interface IBreadcrumbsProps {
  links: IBreadcrumb[];
}

export default function Breadcrumbs({ links }: IBreadcrumbsProps) {
  return (
    <div className="breadcrumbs">
      <Link to={links[links.length - 2]?.link || ''} className="breadcrumbs__back-button">
        <div className="arrow__wrapper">
          <Icon icon={IconscoutIcons.ARROW_LEFT} className="arrow__icon-backward" />
          <Icon icon={IconscoutIcons.ARROW_LEFT} className="arrow__icon-forward" />
        </div>
      </Link>

      {links.map((item, index) => {
        if (item.link) {
          return (
            <div className="breadcrumbs__link__wrapper" key={index}>
              {index !== 0 && <Icon icon={IconscoutIcons.ANGLE_RIGHT} />}
              <Link to={item.link} className="breadcrumbs__link">
                {item.text}
              </Link>
            </div>
          );
        }

        return (
          <div className="breadcrumbs__link__wrapper" key={index}>
            {index !== 0 && <Icon icon={IconscoutIcons.ANGLE_RIGHT} />}
            <span className="breadcrumbs__link breadcrumbs__link--current">{item.text}</span>
          </div>
        );
      })}
    </div>
  );
}
